import { useFetchFlags } from "frontend-admin/src/containers/teamMembers/useTeamMembersAPIHook";
import { SessionType } from "frontend-admin/src/modules/interface";
import { useSelector } from "react-redux";
import { evaluateWorkplaceToWorkplaceReferrals } from "./utils";
import { useLocalStorage } from "react-use";
import { getLocation } from "frontend-admin/src/utils/routes";
import { Button } from "frontend-admin/src/designsystem/Button/Button";
import { Link } from "react-router-dom";
import { BannerProps } from "frontend-admin/src/designsystem/Banner/Banner.type";

const WORKPLACE_REFER_AND_EARN_BANNER = "WORKPLACE_REFER_AND_EARN_BANNER";

export function useWorkplaceReferAndEarnBanner() {
  const { user, profile, userId, type } = useSelector(
    (state: SessionType) => state.session,
  );
  const [referAndEarnBannerVisible, setReferAndEarnBannerVisible] =
    useLocalStorage(`${WORKPLACE_REFER_AND_EARN_BANNER}_${userId}`, true);
  const isFacility = type === "FACILITY";
  const userFlags = useFetchFlags(
    {
      key: profile?.userId,
      name: profile?.name,
      email: profile?.email,
      custom: {
        msa: profile?.fullAddress?.metropolitanStatisticalArea,
        facilitymsa: profile?.fullAddress?.metropolitanStatisticalArea,
        city: profile?.fullAddress?.city,
        state: profile?.fullAddress?.state,
        facilityType: profile?.type,
      },
    },
    profile,
  );
  if (
    referAndEarnBannerVisible === false ||
    (userFlags &&
      evaluateWorkplaceToWorkplaceReferrals(userFlags, user, isFacility) ===
        false)
  ) {
    return null;
  }
  const bannerProps: BannerProps = {
    title: <b>Refer & Earn $750</b>,
    description: (
      <>
        Refer a facility by sharing your personalized referral code and get $750
        in shift credits!
      </>
    ),
    closable: true,
    action: (
      <Link
        to={getLocation("workplaceReferAndEarn", {
          queryParams: { source: "banner" },
        })}
        color="primary"
        type="button"
      >
        <Button variant="primary">
          <b>Refer and Earn</b>
        </Button>
      </Link>
    ),
    type: "info",
    "data-testid": "workplace-refer-and-earn-banner",
    onClose: () => {
      setReferAndEarnBannerVisible(false);
    },
  };
  return {
    bannerProps,
  };
}
